"use strict";
checkList.classy.controller({
    name: 'CheckListController',
    inject: ['$scope', 'AlertService', '$sce', '$timeout', 'ApplicationService', '$q', 'CalculationService', 'RealEstateModelFactory', 
        'ApWizardModelFactory', 'ResetService', 'focus', 'CheckListService', 'PermissionModelService', 'DetermineAwardService', 'zillowDataModelFactory', 'authServiceFactory', 'SliderService', 'SliderFactory', 'TabsService', 'SchoolModelService'],
    init: function()
    {
        this.$.$sce = this.$sce;
        this.$.focus = this.focus;

        this.$.ApplicationService = this.ApplicationService;
        this.$.CheckListService = this.CheckListService;
        this.$.SliderService = this.SliderService;
        this.$.DetermineAwardService = this.DetermineAwardService;
        this.$.TabsService = this.TabsService;
        this.$.AlertService = this.AlertService;
        this.$.schoolinfo = this.SchoolModelService.get()[0];

        this.$.sliderOverOpen = false;
        this.CheckListService.init();
        this.$timeout(function() {
            var $window = $(window).on('resize', function(){
                var height = $(this).height() - 535;
                $('.checklist-accordion .panel-collapse').css("max-height", height + 'px');
            }).trigger('resize');
        }, 100);
        this.$.taxTab = this.authServiceFactory.getAuth().permissions.taxTab
        this.$.confidential = this.authServiceFactory.getAuth().permissions.confidential
        var parent = this;
        /*this.zillowData = [];
        this.$.zillow = []; 
        this.$.ZillowDataModelService = new this.zillowDataModelFactory(this.ApplicationService.getFamilyData().data[0].familyID);
        this.ZillowDataModelService = this.$.ZillowDataModelService;
        this.ApplicationService.getFamilyData().real_estate.map(function(item, index) {
            parent.getZillowData(item, index);
        });*/
    },
    viewLetter: function() {
        if (this.authServiceFactory.getAuth().isISMon==false || this.authServiceFactory.getAuth().isISMon==undefined) {
            this.ApplicationService.getFamilyData().apWizard.viewedLetter = 1;

            var i = parseInt(this.ApplicationService.getFamilyNo());
            var id = this.ApplicationService.getFamilyID(i);
            var ApWizardModelService = new this.ApWizardModelFactory(id);
            ApWizardModelService.put(id, {viewedLetter: 1});
        }
        this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardData/partials/awardDataLetters', 'Family Letter', 'm'));
        //this.SliderService.setPartial('tabs/submodules/awardData/partials/awardDataLetters', 'Family Letter', 'm');
        this.CheckListService.getTotals();
    },
    viewDescriptions: function() {
        if (this.authServiceFactory.getAuth().isISMon==false || this.authServiceFactory.getAuth().isISMon==undefined) {
            this.ApplicationService.getFamilyData().apWizard.viewedOtherDesc = 1;

            var i = parseInt(this.ApplicationService.getFamilyNo());
            var id = this.ApplicationService.getFamilyID(i);
            var ApWizardModelService = new this.ApWizardModelFactory(id);
            ApWizardModelService.put(id, {viewedOtherDesc: 1});
        }
        this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardData/partials/awardDataDesc', 'More Info Descriptions', 'm'));
        //this.SliderService.setPartial('tabs/submodules/awardData/partials/awardDataDesc', 'Descriptions', 'm');
        this.CheckListService.getTotals();
    },
    viewQuestions: function() {
        if (this.authServiceFactory.getAuth().isISMon==false || this.authServiceFactory.getAuth().isISMon==undefined) {
            this.ApplicationService.getFamilyData().apWizard.viewedSsq = 1;

            var i = parseInt(this.ApplicationService.getFamilyNo());
            var id = this.ApplicationService.getFamilyID(i);
            var ApWizardModelService = new this.ApWizardModelFactory(id);
            ApWizardModelService.put(id, {viewedSsq: 1});
        }
        this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardData/partials/awardDataQuestions', 'School Specific Questions', 'm'));
        //this.SliderService.setPartial('tabs/submodules/awardData/partials/awardDataQuestions', 'School Specific Questions', 'm');
        this.CheckListService.getTotals();
    },
    viewFamily: function() {
        if (this.authServiceFactory.getAuth().isISMon==false || this.authServiceFactory.getAuth().isISMon==undefined) {
            this.ApplicationService.getFamilyData().apWizard.viewedFamily = 1;
            
            var i = parseInt(this.ApplicationService.getFamilyNo());
            var id = this.ApplicationService.getFamilyID(i);
            var ApWizardModelService = new this.ApWizardModelFactory(id);
            ApWizardModelService.put(id, {viewedFamily: 1});
        }
        this.SliderService.pushSlider(new this.SliderFactory('applicationOverview/submodules/checkList/partials/familyStructure', 'Family Overview', 'm'));
        //this.SliderService.setPartial('applicationOverview/submodules/checkList/partials/familyStructure', 'Family Overview', 'm');
        this.CheckListService.getTotals();
    },
    viewFlag: function(flag, id) {
        if (flag.english)  // this is a user-defined flag
            this.SliderService.pushSlider(new this.SliderFactory('applicationSlider/partials/interestSlider', flag.english, 'm', id));
        else if (flag.class)  //truth detector flag
            this.SliderService.pushSlider(new this.SliderFactory('applicationSlider/partials/interestSlider', flag.name, 'm', id));
        
        this.CheckListService.interestSelected = flag;
    },
    viewAddedAllowances: function(alert) {
        if (this.PermissionModelService.get(this.authServiceFactory.getAuth().schoolID)[0].readOnly==0)  {
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardCalculation/partials/addedAllowances', alert.text, 'm'));
            if (this.SliderService.returnSliders().length > 0) {
                this.$.currentAlert = alert;
            }
        }
    },
    openAward: function() 
    {
        let title = "Determine Award";
        if (this.SchoolModelService.get()[0].Award_Pref_1 == 1)
            title = "Determine Tuition";
        this.SliderService.pushSlider(new this.SliderFactory('determineAward/partials/determineAward', title, 'l'));
    },
    getField: function(item, field)
    {
        if (typeof item['x' + field] == 'undefined' || item['x' + field] === null || item['x' + field] == '' || item[field] == item['x' + field])
            return item[field] 
        else
            return item['x' + field];
    },
    setAnswer: function(caseNo)
    {
        var caseAttr = 'case' + caseNo + 'ans';
        if (this.ApplicationService.getFamilyData().apWizard[caseAttr].length > 1)
            this.$.answer = JSON.parse(this.ApplicationService.getFamilyData().apWizard[caseAttr]);
        else
            this.$.answer = {'choice':0};

    },
    filterFn: function(alert)
    {
          
    },
    reset: function(resetFunction, name)
    {
        this.ResetService.resetWithPrompt(resetFunction, name);
        this.CheckListService.getTotals();
    },
    setCheckListOverContainer: function(bool, alertName, alert, fIndex){
        if (alertName!=='incomeNotVerified') {
            if (this.PermissionModelService.get(this.authServiceFactory.getAuth().schoolID)[0].readOnly==0)  {
                this.SliderService.pushSlider(new this.SliderFactory('applicationOverview/submodules/checkList/partials/'+alertName, alert.text, 'm'));
                if (typeof fIndex !== "undefined") {
                    this.ApplicationService.setFamilyNo(fIndex);
                }
                if (this.SliderService.returnSliders().length > 0) {
                    this.$.currentAlert = alert;
                }
            }
        }
    },
    setAlertComplete: function(caseNo, answerObj) {
        if (answerObj === undefined) {
            answerObj = " ";
        }
        this.$timeout(() => {
            this.$.currentAlert.state = "success";
            this.$.currentAlert.completedText = this.AlertService.getCompletedText(JSON.stringify(answerObj),
                this.$.currentAlert.name);
            this.$.currentAlert.complete = 1;
        }, 1000);
        this.SliderService.closeSlider(0);

        let i = parseInt(this.ApplicationService.getFamilyNo());
        let id = this.ApplicationService.getFamilyID(i);
        let putData = {};
        let caseAns = caseNo + "ans";
        putData[caseNo] = 0;
        putData[caseAns] = JSON.stringify(answerObj);
        this.ApplicationService.getFamilyData().apWizard[caseNo] = 0;
        this.ApplicationService.getFamilyData().apWizard[caseAns] = putData[caseAns];

        let ApWizardModelService = new this.ApWizardModelFactory(id);
        ApWizardModelService.put(id, putData);

        // If there are two families and we're resetting Tuition Adjustment
        if (this.ApplicationService.getFamCount() === 2 && 
            (this.$.currentAlert.text === "Tuition Adjustment" || this.$.currentAlert.text === "Percent Tuition")) {
            i = (i + 1) % 2; // get the other family index
            this.$.currentAlert = this.$.CheckListService.alerts[i].tuitionAdjustment;

            this.$timeout(() => {
                this.$.currentAlert.state = "success";
                this.$.currentAlert.completedText = this.AlertService.getCompletedText(JSON.stringify(answerObj),
                    this.$.currentAlert.name);
                this.$.currentAlert.complete = 1;
            }, 1000);
            this.SliderService.closeSlider(0);

            let id = this.ApplicationService.getFamilyID(i);
            let putData = {};
            let caseAns = caseNo + "ans";
            putData[caseNo] = 0;
            putData[caseAns] = JSON.stringify(answerObj);
            this.ApplicationService.getFamilyData(i).apWizard[caseNo] = 0;
            this.ApplicationService.getFamilyData(i).apWizard[caseAns] = putData[caseAns];

            let ApWizardModelService = new this.ApWizardModelFactory(id);
            ApWizardModelService.put(id, putData);

        }

        this.CheckListService.init();
    },
    alertPut: function(queue, caseNo, caseValue, answerObj) {
        this.$q.all(queue).then(() => {
            if (caseValue === 0) {
                this.$.setAlertComplete(caseNo, answerObj);
            }
            this.CalculationService.reCalc();
        });
    },
    setTaxVisible: function(taxYear)
    {
        this.SliderService.pushSlider(new this.SliderFactory(
            'applicationOverview/submodules/taxes/partials/taxes',
            taxYear + ' - ' + (parseInt(taxYear) + 1) + ' Taxes', 'm',
            {year: taxYear}));
    },
    openOtherSlider: function(partial, header, size, params)
    {
        this.SliderService.pushSlider(new this.SliderFactory(partial, header, size, params));
        
    }
});
